<template>
<div class="chapter">
<div class="inner_page">
<p class="BOD1" id="ded">For David, Lucy, Owen and Morgan</p>
<h1 class="FBMHD">ACKNOWLEDGMENTS</h1>
<p class="BOD1">As ever, when attempting to produce a book of this nature, I am dependent on the help and expertise of a variety of people. I am particularly grateful to Freya Dangerfield who initially commissioned this book, and to the constant guidance I received from Verity Muir and Hannah Kelly. Jo Lystor has done a great job designing this book. It was always going to be a complicated task but she really has established a wonderful sense of clarity and order. I look forward to doing more books with her. Gratitude is also owed to Ame Verso whose remarkable editing skills once again appear to have changed a pig’s ear into something resembling a silk purse.</p>
<p class="BOD2">I must also thank several close friends who helped in various ways: to Susan Brown for offering guidance with the several high-key techniques, to Ken Hawkins for arranging the lighting for the studio shots, and to Graham Dew who produced the images and text for the excellent workshop on Joiners. The day I spent with Greg Duncan proved particularly useful especially with regard to plug-in filter options, however I must reserve special thanks to my good friend Keith Smith who patiently read through the text and as a consequence made many very useful changes and corrections.</p>
<p class="BOD2">I would also like to thank the numerous individuals who kindly agreed to model, particularly Christina L. Green, Olivia Ames, Juliet Barry, Roberto Dominguez, Josh Prior, Louisa Riddington, Will Spackman, Rebecca Statham, Terry Wareham, Catrin Waugh Baker and finally Rhiannon Waugh Baker. I am sincerely grateful to you all.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?78f2add2